import { Component, OnInit, Input, TemplateRef, ElementRef } from '@angular/core';
import { FilterBoxConfiguration } from './filter-group/filter-box.component';
import { FilterableGridService } from './filterable-grid.service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject, Subject, ReplaySubject } from 'rxjs';
import { AmberApi } from 'app/core/models/api-helpers';
import { RxComponent } from 'app/core/components/common/rx.component';

@Component({
  selector: 'itpx-filterable-grid',
  templateUrl: './filterable-grid.component.html',
  styleUrls: ['./filterable-grid.component.css']
})
export class FilterableGridComponent extends RxComponent implements OnInit {

  @Input() gridFields: any[];
  @Input() filterConfig: FilterBoxConfiguration[];
  @Input() gridConfig: any;
  @Input() url: string;
  @Input() templates: { [key: string]: TemplateRef<ElementRef> } = {};

  // private filterFields: FilterBoxConfiguration[];
  private data$: Observable<any>;
  // private gridConfig: any;
  // private input$: BehaviorSubject<string>;
  private filterParams: string;
  private filterFields$: Observable<FilterBoxConfiguration[]>;
  private gridInput$ = new Subject<string>();
  private filterInput$ = new Subject<string>();

  constructor(
    private service: FilterableGridService
  ) {
    super();
  }

  ngOnInit() {
    let input$ = new ReplaySubject<string>(1);
    this.data$ = input$
      .do(url => console.log(`before switchmap: ${url}`))
      .switchMap(url => this.service.getData(url)).extract(AmberApi.Data).share();
    if (!this.gridConfig)
      this.gridConfig = {};
    this.gridConfig.listDelegate = (params) => {
      this.gridInput$.next(Object.keys(params).map(key => `${key}=${params[key]}`).join('&'));
      return this.data$.map(data => ({
        data: data.gridData,
        flags: { list: true, size: data.total }
      }));
    }

    this.filterFields$ = this.data$
      .map(data =>
        this.filterConfig.map(conf => {
          let tgt = data.filterDescriptors.find(descriptor => descriptor.name === conf.key);
          let keys = Object.keys(tgt.values);
          conf.options = keys.map(key => ({ checked: true, key: key, required: true, value: key, frequency: tgt.key }));
          return conf;
        })
      );

    Observable.combineLatest(this.filterInput$.startWith(''), this.gridInput$).bindToLifecycle(this)
      .do(msg => console.log(`before subscribe: ${msg}`))
      .subscribe(([filterInput, gridInput]) => {
        let filters = '&' + this.filterConfig.map(filter => `externalFilters=${filter.key}`).join('&')
        if (filterInput)
          filterInput = '&' + filterInput;
        input$.next(this.url + '&' + gridInput + filterInput + filters);
      });

  }

  private onFilterChanges(event: any) {
    this.filterInput$.next(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/filterable-grid/filterable-grid.component.ts